import { NgModule } from "@angular/core";
import { CTextPipe } from "./c-text.pipe";
import { CTranslatePipe } from "./c-translate/c-translate.pipe";
import { CHolderPipe } from "./c-holder.pipe";
import { CommonModule } from "@angular/common";
import { CTranslateService } from "./c-translate/c-translate.service";
import { CSafeUrlPipe } from "./c-safe-url.pipe";
import { CGetFieldsPipe } from "./c-get-fields.pipe";
import { CCurrencyPipe } from "./c-currency.pipe";
import { CMDatePipe } from "./c-mdate.pipe";
import { CDatePipe } from "./c-date.pipe";
import { CDateTimePipe } from "./c-datetime.pipe";
import { CSanitizeHtmlPipe } from "./c-sanitize-html.pipe";
import { CLinkifyPipe } from "./c-linkify.pipe";
import { CNumberPipe } from "./c-number.pipe";
import { CHtmlToTextPipe } from "./c-html-to-text.pipe";
import { CGetValueObjectPipe } from "./c-get-value-object.pipe";
import { CFullNamePipe } from "./c-full-name.pipe";
import { CGenderPipe } from "./c-gender.pipe";
import { CPresetCategoryPipe } from "./c-preset-category.pipe";
import { GroupMemberStatusPipe } from "./group-member-status.pipe";
import { GroupMemberLevelPipe } from "./group-member-level.pipe";
import { CountdownPipe } from "./count-down.pipe";
import { ScheduledJobStatusPipe } from "./scheduled-job-status.pipe";

@NgModule({
  imports: [CommonModule],
  declarations: [
    CTextPipe,
    CTranslatePipe,
    CHolderPipe,
    CCurrencyPipe,
    CMDatePipe,
    CDatePipe,
    CDateTimePipe,
    CPresetCategoryPipe,
    CSanitizeHtmlPipe,
    CLinkifyPipe,
    CNumberPipe,
    CSafeUrlPipe,
    CGetFieldsPipe,
    CHtmlToTextPipe,
    CGetValueObjectPipe,
    CFullNamePipe,
    CGenderPipe,
    GroupMemberStatusPipe,
    GroupMemberLevelPipe,
    CountdownPipe,
    ScheduledJobStatusPipe,
  ],
  providers: [CTranslateService],
  exports: [
    CTextPipe,
    CTranslatePipe,
    CHolderPipe,
    CCurrencyPipe,
    CMDatePipe,
    CDatePipe,
    CDateTimePipe,
    CPresetCategoryPipe,
    CSanitizeHtmlPipe,
    CLinkifyPipe,
    CNumberPipe,
    CSafeUrlPipe,
    CGetFieldsPipe,
    CHtmlToTextPipe,
    CGetValueObjectPipe,
    CFullNamePipe,
    CGenderPipe,
    GroupMemberStatusPipe,
    GroupMemberLevelPipe,
    CountdownPipe,
    ScheduledJobStatusPipe,
  ],
})
export class CPipeModule {}
